<template>
  <div class="quescon">
  <ul class="list">
    <li v-for="(item,index) in list" @click="answer(item)">
        <span>{{item.h5Title}}</span>
    </li>
  </ul>
</div>
</template>

<script>
export default {
  name: 'quesList',
  props:['list','type'],
  data () {
    return{
      queLst: [],
      ansShow: false,
      quesTitle: '',
      quesContent: ''
    }
  },
  methods:{
    answer(item) {
      if(item.contentType === 0) {
        this.$router.push({path: '/answer', query: {type: this.type,id:item.id}})
      } else {
        window.location = item.h5Content
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{position: absolute; top: 0; left: 0; background: #f7f7f7; width: 100%; height: 100% ; }
.quesbox{padding: 0.375rem 0 0 0.825rem; height: 100%; background: #fff;overflow:hidden;}
.ques{ color: #333; font-size: 0.7rem; line-height: 1.35rem; height: 1.35rem}
.ques span{width: 0.7rem; height: 0.7rem;line-height: 0.7rem; text-align: center; background: #f42f19; border-radius: 50%; color:#fff; font-size: 0.5rem; float: left; margin:0.3rem 0.25rem 0 0;}
/*.ans{font-size: 0.65rem; color: #999; padding: 0 1.0rem 0 1rem; line-height: 1.0rem}
*/

.quescon{padding-top: 0.3rem;}
.list{ background: #fff;}
.list li{font-size: 0.75rem; color: #333;  line-height: 1.25rem; padding:0.5rem 0; border-bottom:1px solid #EDEDED; margin:  0 0.5rem 0 0.75rem;position: relative; 
}
.list li span{  display: block;overflow: hidden; margin-right:.5rem;}
.list li:last-child{border:none;}
.list li:after{content: '';display: block; width:0.45rem; height: 0.45rem; position: absolute; right:0; top:50%; margin-top: -0.225rem; border-top:0.075rem solid #ccc; border-right: 0.075rem solid #ccc;transform:rotate(45deg);-ms-transform:rotate(45deg); -moz-transform:rotate(45deg);  -webkit-transform:rotate(45deg);-o-transform:rotate(45deg);   }
</style>



// WEBPACK FOOTER //
// src/components/quesList.vue